const fullConfig = {
  theme: {
    colors: {
      transparent: {
        DEFAULT: "transparent",
      },
      black: {
        DEFAULT: "#000000",
      },
      blue: {
        DEFAULT: "#004275",
      },
      teal: {
        DEFAULT: "#479ebc",
        darker: "#00708d",
      },
      white: {
        DEFAULT: "#ffffff",
      },
      gray: {
        light: "#e8eaeb",
        DEFAULT: "#58595b",
      },
      yellow: {
        DEFAULT: "#FF9A3C",
        dark: "#DA8E49",
      },
    },
    screens: {
      sm: "640px",
      md: "768px",
      lg: "1024px",
      xl: "1280px",
    },
    spacing: {
      "0": "0",
      "1": "0.25rem",
      "2": "0.5rem",
      "3": "0.75rem",
      "4": "1rem",
      "5": "1.25rem",
      "6": "1.5rem",
      "8": "2rem",
      "10": "2.5rem",
      "12": "3rem",
      "16": "4rem",
      "20": "5rem",
      "24": "6rem",
      "32": "8rem",
      "40": "10rem",
      "48": "12rem",
      "56": "14rem",
      "64": "16rem",
      px: "1px",
    },
  },
}

export default fullConfig
